import { GET_DASHBOARD_SUCCESS } from './dashboard.types';

const initialState = {
  dashboardData: null,
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_SUCCESS:
      return { ...state, dashboardData: action.payload };
    default:
      return state;
  }
};
